module.exports = __webpack_public_path__ + "img/iconLiShiGuanKouXieLiao.34e0da97.svg";